import PropTypes from 'prop-types';

import { CurrentNetworkProvider } from 'hb-react/frontoffice/contexts/DefaultAppContexts';
import { TopicProvider } from 'hb-react/frontoffice/contexts/TopicContext';
import PageCustomizableContainer from 'hb-react/shared/apps/PageCustomizables/containers/PageCustomizableContainer';

const PageCustomizableStandalone = ({ network, topic, ...props }) => (
  <CurrentNetworkProvider currentNetwork={network}>
    <TopicProvider topic={topic}>
      <PageCustomizableContainer app="publicoffice" {...props} />
    </TopicProvider>
  </CurrentNetworkProvider>
);

PageCustomizableStandalone.propTypes = {
  network: PropTypes.object.isRequired,
};

export default PageCustomizableStandalone;
